import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { ANIMATION_FUNCTION, IconButton } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { StyledFilterItemCardItemWrapper } from "app/pages/sales-intelligence/common-components/filters-panel/components/FilterItemCard/styles";

export const StyledFilterCardActions = styled(Flex)`
    justify-content: flex-end;
    align-items: center;
`;

export const StyledPinButton = styled(IconButton)<{ iconColor: string }>`
    ${SWReactIcons} {
        & svg path {
            fill: ${({ iconColor }) => iconColor};
            transition: fill 200ms ${ANIMATION_FUNCTION};
        }
    }
`;

export const StyledPinButtonWrapper = styled.div<{ isPinned: boolean; isDisabled: boolean }>`
    overflow: hidden;
    position: relative;
    height: 32px;
    padding-left: ${({ isPinned }) => (isPinned ? "2px" : 0)};
    width: ${({ isPinned }) => (isPinned ? "32px" : 0)};
    opacity: ${({ isPinned }) => (isPinned ? 1 : 0)};
    transition:
        all 200ms ${ANIMATION_FUNCTION},
        opacity 200ms ${ANIMATION_FUNCTION};

    cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};

    ${StyledFilterItemCardItemWrapper}:hover & {
        padding-left: 2px;
        width: 32px;
        opacity: 1;
    }

    ${StyledPinButton} {
        position: absolute;
        top: 0;
        right: 0;
    }
`;
